import React from 'react';

interface PerspectivesAiDisclosureProps {
  onLearnMoreClick?: () => void;
}

const PerspectivesAiDisclosure: React.FC<PerspectivesAiDisclosureProps> = ({
  onLearnMoreClick
}) => (
  <div
    className="flex items-center gap-2 px-3.5 py-2.5 rounded-lg mb-4"
    style={{ background: 'rgba(15,23,42,0.03)' }}
  >
    <span
      className="shrink-0 text-[9px] font-extrabold tracking-wide px-1.5 py-0.5 rounded"
      style={{ background: '#0f172a', color: '#a5f3fc', fontFamily: "'JetBrains Mono', monospace" }}
    >
      AI
    </span>
    <span className="text-[12.5px] text-slate-500 leading-snug">
      Anchor perspectives are written by AI personas. Community members contribute their own.{' '}
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          onLearnMoreClick?.();
        }}
        className="text-green-600 font-semibold cursor-pointer hover:underline bg-transparent border-none p-0 inline"
      >
        Learn more
      </button>
    </span>
  </div>
);

export default PerspectivesAiDisclosure;
